<div class="rx-intuitive-additional-info-modal">
	<tlk-modal-header>
		{{ 'ToothEditor.AdditionalInfo' | translate }}
		<button tlkButton variant="ghost" size="l" right-icon type="button" (click)="onCancel()">
			<tlk-close-empty-icon class="tlk-icon_size_l" />
		</button>
	</tlk-modal-header>

	<rx-banner
		*ngIf="data.isReadOnly"
		class="rx-intuitive-additional-info-modal__read-only-banner"
		type='info'
		appearance="intuitive"
		[message]="'ReadOnlyMode.ReadOnlyMessage' | translate"
	></rx-banner>

	<tlk-modal-content>
		<rx-intuitive-crown-additional-fields
			[materialOption]="data.crownContext.materialOption"
			[materialIdForShadeOptions]="data.crownContext.materialId"
			[shadeSystemId]="data.crownContext.shadeSystemId"
			[isOtherShadeSystemSelected]="data.crownContext.isOtherShadeSystem"
			[initialValues]="data.initialValues"
			[isReadOnly]="data.isReadOnly"
			[shouldValidateForSend]="data.shouldValidateForSend"
			(additionalInfoChange)="onAdditionalInfoChange($event)"
			(clearedFieldsChange)="onClearedFieldsChange($event)"
		/>
	</tlk-modal-content>

	<tlk-modal-footer *ngIf="!data.isReadOnly" class="rx-intuitive-additional-info-modal__footer">
		<ng-container ngProjectAs="[right-buttons]">
			<button
				class="rx-intuitive-additional-info-modal__btn-cancel"
				tlkButton
				variant="secondary"
				size="m"
				type="button"
				(click)="onCancel()"
			>
				{{ 'NotesSection.Cancel' | translate }}
			</button>
			<button
				class="rx-intuitive-additional-info-modal__btn-save"
				tlkButton
				variant="primary"
				size="m"
				[disabled]="
					!materialOption?.PrepDesignVisible &&
					!materialOption?.MarginDesignVisible &&
					!materialOption?.StumpShadeVisible &&
					isShadeDisabled
				"
				type="button"
				(click)="onSave()"
			>
				{{ 'NotesSection.Save' | translate }}
			</button>
		</ng-container>
	</tlk-modal-footer>
</div>
